import { combineReducers } from "redux";
import service_invoice from "../features/admin/service_invoice/Slice";

const serviceInvoiceSection = combineReducers({
  service_invoice: service_invoice,
});

export default serviceInvoiceSection;
